import AnamnesiEdit from "./components/AnamnesiEdit.vue";
import AnamnesiView from "./components/AnamnesiView.vue";
import AnamnesiList from "./components/AnamnesiList.vue";

export default {
    AnamnesiEdit,
    AnamnesiView,
    AnamnesiList,
};
